import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { QUERY_PRESETS, QueryPreset } from "./queryPresets";

import { CustomAxiosError } from "@/shared/model/types/axiosError";

interface QueryOverrides {
    staleTime?: number;
    gcTime?: number;
    refetchOnWindowFocus?: boolean;
    refetchOnMount?: boolean;
    refetchOnReconnect?: boolean;
    refetchInterval?: number | false;
    retry?: number | boolean;
}

interface CreateQueryOptionsParams<TResponse, TSelected = TResponse> {
    queryKey: QueryKey;
    queryFn: () => Promise<TResponse>;
    preset?: QueryPreset;
    select?: (data: TResponse) => TSelected;
    enabled?: boolean;
    overrides?: QueryOverrides;
}

export function createQueryOptions<TResponse, TSelected = TResponse>({
    queryKey,
    queryFn,
    preset = "default",
    select,
    enabled,
    overrides,
}: CreateQueryOptionsParams<TResponse, TSelected>): UseQueryOptions<
    TResponse,
    CustomAxiosError,
    TSelected,
    QueryKey
> {
    const presetConfig = QUERY_PRESETS[preset];

    return {
        queryKey,
        queryFn,
        ...presetConfig,
        ...(select && { select }),
        ...(enabled !== undefined && { enabled }),
        ...overrides,
    };
}
